import AddSubscriptionForm from 'src/components/Forms/AddSubscriptionForm';
import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';

const AddSubscriptionModal = () => (
  <ModalBase name={MODALS.addSubscription} size={MODALS_SIZE.large} form={FORM.get_invoice}>
    <AddSubscriptionForm />
  </ModalBase>
);

export default AddSubscriptionModal;
